import { Directive, HostBinding, HostListener, OnInit, OnDestroy, ElementRef, Renderer2, Input } from '@angular/core';
import { ConnectionService } from '../services/connection.service';
import { Subscription } from 'rxjs';
import { ToastUtils } from 'src/app/utils/toast_builder';
import { PopoverComponent } from 'src/app/widgets/popover/popover.component';

@Directive({
    selector: '[disableIfOffline]'
})
export class DisableIfOfflineDirective implements OnInit, OnDestroy {
    @Input()
    disableIfOffline = false;
    private subscription: Subscription;
    private overlayElement: HTMLElement | null = null;

    // @HostBinding('disabled')
    disabled: boolean;

    // Ensure the host remains clickable when visually disabled
    @HostBinding('style.position')
    hostPosition = 'relative';



    @HostBinding('style.opacity')
    get hostOpacity(): string {
        return this.disabled ? '0.5' : '1';
    }
    constructor(
        private connectionService: ConnectionService,
        private toastUtils: ToastUtils,
        private host: ElementRef<HTMLElement>,
        private renderer: Renderer2
    ) { }

    ngOnInit(): void {
        this.subscription = this.connectionService.isOnline$.subscribe((isOnline) => {
            this.disabled = this.disableIfOffline || !isOnline;

            console.log(this.disableIfOffline)
            this.updateOverlay();
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.removeOverlay();
    }

    private updateOverlay(): void {
        if (this.disabled || this.disableIfOffline) {
            this.addOverlay();
        } else {
            this.removeOverlay();
        }
    }

    @HostListener('click', ['$event'])
    onHostClick(event: Event): void {
        if (!this.disabled) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.showOfflinePopover();
    }

    private addOverlay(): void {
        if (this.overlayElement) {
            return;
        }
        // Create a transparent overlay div to capture clicks
        const overlay = this.renderer.createElement('div');
        this.renderer.setStyle(overlay, 'position', 'absolute');
        this.renderer.setStyle(overlay, 'top', '0');
        this.renderer.setStyle(overlay, 'left', '0');
        this.renderer.setStyle(overlay, 'width', '100%');
        this.renderer.setStyle(overlay, 'height', '100%');
        this.renderer.setStyle(overlay, 'z-index', '9999');
        this.renderer.setStyle(overlay, 'background', 'transparent');

        this.renderer.listen(overlay, 'click', (event: Event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showOfflinePopover();
        });

        this.renderer.appendChild(this.host.nativeElement, overlay);
        this.overlayElement = overlay;
    }

    private removeOverlay(): void {
        if (this.overlayElement) {
            this.renderer.removeChild(this.host.nativeElement, this.overlayElement);
            this.overlayElement = null;
        }
    }

    private async showOfflinePopover(): Promise<void> {
        await this.toastUtils.popOverBuilder(
            {
                key1: 'action_not_permetted_offline',
                canBeClosed: true,
                is_confirm_needed: false,
                is_info_popover: true,
                is_loader_needed: false,
            },
            PopoverComponent,
            'popover-custom',
            null,
            true,
            true
        );
    }
}
